import { Form, ApplicationTemplateDto, ExistingFormElement } from '../models';

/**
 * Form builder state interface
 */
export interface FormBuilderState {
  /** Current form being edited */
  currentForm: Form | null;
  /** Loading state */
  loading: boolean;
  /** Error state */
  error: string | null;
  /** Existing form elements loaded from API */
  existingFormElements: ExistingFormElement[];
  /** Loading state for existing form elements */
  loadingExistingElements: boolean;
  /** Error state for existing form elements */
  existingElementsError: string | null;
  /** Forms list loaded from API */
  forms: ApplicationTemplateDto[];
  /** Loading state for forms list */
  loadingForms: boolean;
  /** Error state for forms list */
  formsError: string | null;
  /** Loading state for getting form by ID */
  loadingFormById: boolean;
  /** Error state for getting form by ID */
  formByIdError: string | null;
  /** Read-only mode state */
  isReadOnly: boolean;
}

/**
 * Initial state
 */
export const initialState: FormBuilderState = {
  currentForm: null,
  loading: false,
  error: null,
  existingFormElements: [],
  loadingExistingElements: false,
  existingElementsError: null,
  forms: [],
  loadingForms: false,
  formsError: null,
  loadingFormById: false,
  formByIdError: null,
  isReadOnly: false
};

